import _ from 'lodash'

export default {
  create: ({commit, state, getters}, payload) => {
    return new Promise((resolve, reject) => {
      let item = _.extend({},
        {
          id: 'Decor' + state.items.length
        }, payload)
      commit('create', item)
      resolve(item.id)
    })
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/decor/actions.js